// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"48198676","295":"5c665d1d","583":"5e8bc5e4","807":"b37f645b","818":"87a590c5","899":"33b964a4","900":"815301c4","996":"59e27032"}[chunkId] + ".chunk.js";
};